import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../components/commons";
import { useEffect } from "react";

import  { Toaster } from "react-hot-toast";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import { resetSession } from "../../redux/auth";
import {
  resetFixedAssetRegisterError,
  resetFixedAssetRegisterMessage,
  resetFixedAssetRegisterStatusCode,
  resetFixedAssetRegisterSuccess,
} from "../../redux/fixedAsset";
import { getAuditSessionAction } from "../../redux/fixedAsset/actions";
import { EmptyList } from "../../assets/images";
import AuditSessionTable from "../../components/AuditSessionTable/AuditSessionTable";
import { AUDIT_SESSION_HEADERS } from "../../constant/tableHeadersConstants/fixedAssetConstant/auditSession";
import { LoginResponseType } from "../../redux/auth/authTypes";
import { GetAuditSessionPayloadType } from "../../commonTypes/fixedAssetRegisterTypes";
import { AuditSessionListType } from "../../redux/fixedAsset/fixedAssetRegisterTypes";

type AppProps = {
  history: any;
  fetching: boolean;
  message: string | null;
  success: null | number;
  error: null | string;
  statusCode: null | number;
  token: null | string;
  auditSessionListing: AuditSessionListType[] | [];
  dispatchResetSession: () => void;
  dispatchResetFixedAssetRegisterError: () => void;
  dispatchResetFixedAssetRegisterSuccess: () => void;
  dispatchResetFixedAssetRegisterStatusCode: () => void;
  dispatchResetFixedAssetRegisterMessage: () => void;
  dispatchGetAuditSessionList: (data: GetAuditSessionPayloadType) => void;
  loginData: LoginResponseType;
};
const AuditSession = ({
  history,
  fetching,
  message,
  success,
  error,
  token,
  statusCode,
  auditSessionListing,
  loginData,
  dispatchResetSession,
  dispatchResetFixedAssetRegisterError,
  dispatchResetFixedAssetRegisterSuccess,
  dispatchResetFixedAssetRegisterStatusCode,
  dispatchResetFixedAssetRegisterMessage,
  dispatchGetAuditSessionList,
}: AppProps) => {
  const client_code = history?.location?.state?.client_code;
  const company_name = history?.location?.state?.company_name;

  useEffect(() => {
    dispatchResetFixedAssetRegisterError();
    dispatchResetFixedAssetRegisterSuccess();
    dispatchResetFixedAssetRegisterStatusCode();
    dispatchResetFixedAssetRegisterMessage();
  }, []);

  useEffect(() => {
    let finalData = {
      token,
      client_code,
    };
    dispatchGetAuditSessionList(finalData);
  }, []);

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetFixedAssetRegisterError();
            }}
          />
        );
      }
    }

    return false;
  };
  return (
    <div className="row">
      <div className="col-md-6 mb-3">
        <CommonHeader
          title="Audit Session"
          company_name={company_name}
          client_code={client_code}
        />
      </div>
      <div className="col-md-12">
        <div className="jobs-card">
          <div className="header">
            <div className="left-header">
              <div className="heading">Audit session List</div>
              {!fetching &&  <div className="sub-heading" style={{ marginTop: "-22px" }}>{`Total ${auditSessionListing?.length ? auditSessionListing?.length : 0} audits found`}</div>}

            </div>
            <div className="right-header">
              <button
                onClick={() =>
                  history?.push({
                    pathname: `/fixed-asset-register/audit-session/${client_code}/add`,
                    state: { client_code, company_name },
                  })
                }
                className="btn btn-primary"
              >
                + Add Audit
              </button>
            </div>
          </div>
          <div>
            {fetching ? (
              <TableLoader Rows={10} ColumnPerRow={7} />
            ) : auditSessionListing?.length > 0 ? (
              <AuditSessionTable
                data={auditSessionListing}
                fetching={fetching}
                tableHeaders={AUDIT_SESSION_HEADERS}
                history={history}
                loginData={loginData}
              />
            ) : (
              <div className="mt-5 pb-5">
                {!fetching && auditSessionListing?.length === 0 && (
                  <EmptyListPage
                    title="No Audit List Found!"
                    image={EmptyList}
                    imageWidth="30%"
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <Toaster />
      {handleErrorModal()}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.fixedAssetRegister.success,
  fetching: state.fixedAssetRegister.fetching,
  message: state.fixedAssetRegister.message,
  statusCode: state.fixedAssetRegister.statusCode,
  error: state.fixedAssetRegister.error,
  auditSessionListing: state.fixedAssetRegister.auditSessionListing,
  loginData: state.auth.loginData,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetFixedAssetRegisterSuccess: () =>
    dispatch(resetFixedAssetRegisterSuccess()),
  dispatchResetFixedAssetRegisterError: () =>
    dispatch(resetFixedAssetRegisterError()),
  dispatchResetFixedAssetRegisterMessage: () =>
    dispatch(resetFixedAssetRegisterMessage()),
  dispatchResetFixedAssetRegisterStatusCode: () =>
    dispatch(resetFixedAssetRegisterStatusCode()),
  dispatchGetAuditSessionList: (data: GetAuditSessionPayloadType) =>
    dispatch(getAuditSessionAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AuditSession);
